import React from 'react'
import './styles.sass'

export default function Footer(){
    return(
        <footer>
			<p>Power by Sears </p>
		</footer>
    )
}